import { memo } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";

function Error() {
  const { errorMessage } = useLiveStreamAppContext();
  return (
    <>
      <div className="reactivate-wrpapper">
        <div className="div-block-99 no100pad" style={{ top: "0" }}>
          <div className="div-block-100">
            <div className="paddingblock">
              <div className="moon-img-block">
                <img
                  className="moon-img"
                  alt=""
                  src="https://vagaro.azureedge.net/static-content/Images/moon-img.png"
                  width="57.5"
                />
                <img
                  alt=""
                  src="https://vagaro.azureedge.net/static-content/Images/closed-bus-img.png"
                  width="180"
                />
              </div>
              <h1
                id="ctl00_cpPageContent_errorMsg"
                className="web-display-medium-strong"
              >
                {errorMessage}
              </h1>
              <div className="_15-spacer"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(Error);
